import * as React from 'react';
import styled from 'styled-components';

import { Selector } from '@longline/aqua-ui/inputs/Selector';

import { Role } from '../../../api/Permission';

interface IProps {
  value?: Role[];
  onChange?: (value: Role[]) => void;
  disabled?: boolean;
}

const RoleControl = (props: IProps) => {

  const [value, setValue] = React.useState<Role[]>([]);

  React.useEffect(() => {
    setValue(props.value ?? []);
  }, [props.value]);

  const handleToggleRole = (role: Role) => {
    let roles = [];
    if(value.includes(role)) {
      roles = value.filter(r => r !== role);
    } else {
      roles = [...value, role];
    }
    setValue(roles);
    if(props.onChange) props.onChange(roles);
  }

  return (
    <Wrapper>
      <Selector disabled={props.disabled} label="Power user" checked={(value || []).includes(Role.PowerUser)} onChange={() => handleToggleRole(Role.PowerUser)}/>
      <Selector disabled={props.disabled} label="Administrator" checked={(value || []).includes(Role.Admin)} onChange={() => handleToggleRole(Role.Admin)}/>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 8px 0 8px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: start;
  width: 100%;
  & span { 
    color: ${p => p.theme.colors.neutral[10]}; 
    font: ${p => p.theme.font.bodyMedium};
  }
`

export { RoleControl }
